// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-container {
  position: fixed;
  top: 10px;
  left: 10px;
  top: 0;
  left: 0;
}

.menu-open-button {
  cursor: pointer;
  z-index: 1500;
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  appearance: none;
  -webkit-appearance: none;
}

.menu-open-button > svg {
  cursor: pointer;
  height: 32px;
  width: 32px;
  margin: 16px;
  fill: #116466;
}

.menu-open-button > svg:hover {
  cursor: pointer;
  fill: #106162;
}

.menu-close-button {
  display: block;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  z-index: 1500;
  border: none;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  -webkit-font-smoothing: inherit;
  -moz-osx-font-smoothing: inherit;
  appearance: none;
  -webkit-appearance: none;
}

.menu-close-button > svg {
  cursor: pointer;
  height: 32px;
  width: 32px;
  margin: 16px;
  fill: #116466;
}

.menu-close-button > svg:hover {
  cursor: pointer;
  fill: #106162;
}


.menu {
  position: absolute;
  top: 0;
  left: -170px; 
  width: 170px;
  height: 100vh;
  max-width: 100vw;
  background-color: #2c3531;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
  transition: left 0.3s ease;
}

.menu > a {
  margin-top: 25px;
  display: block;
  width: 170px;
}

.menu > a > svg {
  height: 64px;
  max-width: 170px;
}

.menu.open {
  left: 0; /* Slide in when open */
}

.menu > .menu-links {
  color: #116466
}

.menu a {
  text-decoration: none; 
  color: #116466; 
}

.menu-links-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100% - 68px - 68px - 25px);
}

.menu-links {
  list-style-type: none;
  padding-inline-start: 15px;
  margin: 0;
}

.menu-links > li {
  padding-top: 5px;
  padding-bottom: 5px;
}

.menu-links svg {
  max-width: 64px;
  height: 64px;
}

.disabled-link {
  pointer-events: none;
  color: #0f4a4b; 
}

.menu-links-top {
  padding-top: 15px;
}

.menu-links-bottom {
  padding-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/client/Components/Menu/Menu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,MAAM;EACN,OAAO;AACT;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,YAAY;EACZ,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,OAAO,EAAE,uBAAuB;AAClC;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".menu-container {\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  top: 0;\n  left: 0;\n}\n\n.menu-open-button {\n  cursor: pointer;\n  z-index: 1500;\n  border: none;\n  margin: 0;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  -webkit-font-smoothing: inherit;\n  -moz-osx-font-smoothing: inherit;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.menu-open-button > svg {\n  cursor: pointer;\n  height: 32px;\n  width: 32px;\n  margin: 16px;\n  fill: #116466;\n}\n\n.menu-open-button > svg:hover {\n  cursor: pointer;\n  fill: #106162;\n}\n\n.menu-close-button {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  cursor: pointer;\n  z-index: 1500;\n  border: none;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  -webkit-font-smoothing: inherit;\n  -moz-osx-font-smoothing: inherit;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.menu-close-button > svg {\n  cursor: pointer;\n  height: 32px;\n  width: 32px;\n  margin: 16px;\n  fill: #116466;\n}\n\n.menu-close-button > svg:hover {\n  cursor: pointer;\n  fill: #106162;\n}\n\n\n.menu {\n  position: absolute;\n  top: 0;\n  left: -170px; \n  width: 170px;\n  height: 100vh;\n  max-width: 100vw;\n  background-color: #2c3531;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);\n  transition: left 0.3s ease;\n}\n\n.menu > a {\n  margin-top: 25px;\n  display: block;\n  width: 170px;\n}\n\n.menu > a > svg {\n  height: 64px;\n  max-width: 170px;\n}\n\n.menu.open {\n  left: 0; /* Slide in when open */\n}\n\n.menu > .menu-links {\n  color: #116466\n}\n\n.menu a {\n  text-decoration: none; \n  color: #116466; \n}\n\n.menu-links-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: calc(100% - 68px - 68px - 25px);\n}\n\n.menu-links {\n  list-style-type: none;\n  padding-inline-start: 15px;\n  margin: 0;\n}\n\n.menu-links > li {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.menu-links svg {\n  max-width: 64px;\n  height: 64px;\n}\n\n.disabled-link {\n  pointer-events: none;\n  color: #0f4a4b; \n}\n\n.menu-links-top {\n  padding-top: 15px;\n}\n\n.menu-links-bottom {\n  padding-bottom: 15px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
